import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { gtmEventHandler } from '@common/utils/gtm';

import { Button } from '@vectord/ui';

import { fcSelector } from '@alumni_v2/selectors/reviews';
import {
  registerFcEvent,
  setIsSignupSidebarOpen,
} from '@alumni_v2/stores/reviews/actions';
import { isUserLoggedIn } from '@alumni_v2/utils/helpers';


const FcRegisterButton = ({ className, source, onClose }) => {
  const dispatch = useDispatch();

  const {
    isFcRegistered,
    isFcRegistering,
    fcEventData,
  } = useSelector(fcSelector);

  const handleClick = useCallback(async () => {
    if (isFcRegistering) return;

    gtmEventHandler(
      'cta',
      `free_class_register_btn_${source}`,
      'click',
      'alumni_directory',
    );

    if (!isUserLoggedIn()) {
      if (onClose) onClose();
      dispatch(setIsSignupSidebarOpen(true));
      document.getElementsByClassName('alumni-v2-auth-trigger')[0].click();
      return;
    }

    if (isFcRegistered) {
      window.open(`/event/${fcEventData.slug}`, '_blank');
    } else {
      dispatch(registerFcEvent());
    }
  }, [dispatch, fcEventData.slug,
    isFcRegistered, isFcRegistering, onClose, source]);

  const registerButtonVariant = useMemo(() => {
    if (isFcRegistered) return 'alert-success';
    return 'hero';
  }, [isFcRegistered]);

  const getClassName = useMemo(
    () => (isFcRegistering ? `${className} vd-opacity-70` : className),
    [className, isFcRegistering],
  );

  return (
    <Button
      buttonType="solid"
      size="m"
      title={isFcRegistered ? 'View Details'
        : 'Register for Free Class'}
      iconRight={isFcRegistered ? 'arrow-up-right' : ''}
      variants={registerButtonVariant}
      upperCase={false}
      onClick={handleClick}
      className={getClassName}
    />
  );
};

export default FcRegisterButton;
